module.exports = __webpack_public_path__ + "img/slide-16.d4150441.png";